import type { RequestPayload } from "@inertiajs/core";
import { usePage } from "@inertiajs/react";
import { Divider, Fieldset, Stack, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import type { Company } from "../../models/company";
import { SaveButton } from "../button/SaveButton";

type CompanyProps = {
  company?: Company;
  submitButtonLabel: string;
  onSubmit: (values: RequestPayload) => void;
};

type FormErrors = {
  name?: string[];
};

export function CompanyForm({ company, onSubmit, submitButtonLabel }: CompanyProps) {
  const { errors } = usePage<{ errors: FormErrors }>().props;

  const companyForm = useForm({
    mode: "uncontrolled",
    initialValues: {
      name: company?.name,
    },
  });

  return (
    <form onSubmit={companyForm.onSubmit((values) => onSubmit(values))}>
      <Fieldset legend="Details">
        <Stack maw="60rem">
          <TextInput label="Name" key={companyForm.key("name")} {...companyForm.getInputProps("name")} error={errors?.name} />
          <Divider />
          <SaveButton label={submitButtonLabel} />
        </Stack>
      </Fieldset>
    </form>
  );
}
